import { H4, H6, Image, P } from '../../../../../AbstractElements'
import { EmailAddress, General } from '../../../../../utils/Constant'
import { PrintPreviewPropsType } from '../../../../../Type/Application/Contacts/Contacts'
import { dynamicImage } from 'src/Service'
import { forwardRef } from 'react';

const PrintPreview = forwardRef<HTMLDivElement, PrintPreviewPropsType>(({ selectedUser }, ref) => {
  return (
    <div className="profile-mail pt-0" id="DivIdToPrint" ref={ref}>
      <div className="d-flex">
        <Image className="img-50 img-fluid m-r-20 rounded-circle" src={dynamicImage(selectedUser.avatar)} alt="users" />
        <div className="flex-grow-1 mt-0">
          <H4>
            <span id="printname">{selectedUser.name}</span>
            <span id="printlast">{selectedUser.sureName}</span>
          </H4>
          <P>{selectedUser.email}</P>
        </div>
      </div>
      <div className="email-general">
        <H6>{General}</H6>
        <P>{EmailAddress}:<span className="font-primary" id="mailadd">{selectedUser.email}</span></P>
      </div>
    </div>
  )
}
);

export default PrintPreview